export var VerticalizedLandingPageShopType;
(function (VerticalizedLandingPageShopType) {
    VerticalizedLandingPageShopType["VERTICALIZED_LANDING_PAGE_SHOP_TYPE_UNKNOWN"] = "VERTICALIZED_LANDING_PAGE_SHOP_TYPE_UNKNOWN";
    VerticalizedLandingPageShopType["SPA_SALON"] = "SPA_SALON";
    VerticalizedLandingPageShopType["CAFE_RESTAURANT"] = "CAFE_RESTAURANT";
})(VerticalizedLandingPageShopType || (VerticalizedLandingPageShopType = {}));
